import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { LoginResult } from "../../models/login-result.model";

@Component({
  selector: "up-session",
  templateUrl: "./session.component.html",
  styleUrl: "./session.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UpSessionComponent implements OnInit {
  data: LoginResult | null = !localStorage.getItem("session")
    ? null
    : <LoginResult>JSON.parse(localStorage.getItem("session")!);

  constructor(@Inject("APP_WORKSPACE_URL") private workspaceAppUrl: string) {}

  ngOnInit(): void {
    window.addEventListener(
      "message",
      (e) => {
        alert(e.origin);
        alert(this.workspaceAppUrl);
        if (e.origin != this.workspaceAppUrl) return;
        if (!("session" in e.data)) return;
        if (!e.data.session) localStorage.removeItem("session");
        else localStorage.setItem("session", e.data.session);

        this.data = e.data.session;
      },
      false,
    );
  }
}
